import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, ChevronRight } from "lucide-react";
import { UPLOADS_URL } from "../../config/constants";
import { useGetAllChildren } from "../../query/childQuery";

function initials(firstName = "", lastName = "") {
  return `${(firstName || "").charAt(0)}${(lastName || "").charAt(0)}`.toUpperCase() || "S";
}

function studentName(child) {
  return `${child?.firstName || ""} ${child?.lastName || ""}`.trim() || "Student";
}

function classLabel(child) {
  return child?.classroom?.classroomName || "Unassigned";
}

function StudentAvatar({ student }) {
  const [broken, setBroken] = useState(false);
  const showImage = Boolean(student?.image) && !broken;

  return (
    <span className="side-card-student-avatar">
      {showImage ? (
        <img src={`${UPLOADS_URL}/${student.image}`} alt="" onError={() => setBroken(true)} />
      ) : (
        <span className="side-card-avatar-fallback">{initials(student.firstName, student.lastName)}</span>
      )}
    </span>
  );
}

function StudentRow({ student, onOpen }) {
  return (
    <button type="button" className="side-card-row side-card-student-row" onClick={() => onOpen(student._id)}>
      <div className="side-card-person">
        <StudentAvatar student={student} />
        <div className="side-card-copy">
          <p className="side-card-name">{studentName(student)}</p>
          <p className="side-card-meta">{classLabel(student)}</p>
        </div>
      </div>
      <span className="side-card-row-arrow" aria-hidden="true">
        <ChevronRight size={14} strokeWidth={2.2} />
      </span>
    </button>
  );
}

function StudentSkeleton() {
  return (
    <div className="side-card-row side-card-student-skel" aria-hidden="true">
      <span className="side-card-skel is-avatar" />
      <div className="side-card-copy">
        <span className="side-card-skel is-name" />
        <span className="side-card-skel is-meta" />
      </div>
    </div>
  );
}

function RecentStudents() {
  const navigate = useNavigate();
  const { data, isLoading } = useGetAllChildren({
    page: "1",
    limit: "5",
    status: "ACTIVE",
  });

  const students = data?.docs || [];
  const openStudent = (id) => navigate(`/children/${id}`);

  return (
    <section className="side-card side-card-students">
      <div className="side-card-head">
        <h2 className="side-card-title">Recent Students</h2>
      </div>

      <div className={`side-card-list${!isLoading && students.length === 0 ? " is-empty" : ""}`}>
        {isLoading ? (
          <>
            <StudentSkeleton />
            <StudentSkeleton />
            <StudentSkeleton />
            <StudentSkeleton />
            <StudentSkeleton />
          </>
        ) : students.length === 0 ? (
          <p className="side-card-empty-text">No students yet</p>
        ) : (
          students.map((student) => (
            <StudentRow key={student._id} student={student} onOpen={openStudent} />
          ))
        )}
      </div>

      <button type="button" className="side-card-footer" onClick={() => navigate("/children")}>
        View all
        <ArrowRight size={13} strokeWidth={2.2} />
      </button>
    </section>
  );
}

export default RecentStudents;
